module.exports = __webpack_public_path__ + "assets/EquidistantParallelDetailed.56c209ce00e3f5086b51eb88f28f9459.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/EquidistantParallelDetailed.png
// module id = 507
// module chunks = 0